export const PAPATOO_BASEURL = 'https://rubopop.hi.nikolaz.tech';
export const PAPATOO_V1_CLIENTS = '/api/v1/clients';